exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share-control-container{display:flex;padding-bottom:5px;padding-top:8px}.share-control-container>.share-control-option-container{margin-right:15px}.share-control-container.is-detailed{margin-top:5px}.media-share-icon{cursor:pointer}.media-share-icon.is-favorite{color:#fec42c}.media-share-icon .media-share-icon-title{color:#333;margin-left:5px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;line-height:14px}", ""]);

// exports
